import React, { Fragment, useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
//import PageTitle from "../../../layouts/PageTitle";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CircularProgress } from "@mui/material";
import * as constants from "../../../utils/Constants";

const ApplyJob = () => {
  const history = useHistory();
  let state = useLocation().state;
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  const [qualifications, setQualifications] = useState([]);
  const [jobAssessment, setJobAssessment] = useState(
    state?.assessment ? state.assessment : []
  );
  const [isSpin, setIsSpin] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.addEventListener("wheel", function (event) {
      if (
        document.activeElement.type === "number" &&
        document.activeElement.classList.contains("noscroll")
      ) {
        document.activeElement.blur();
      }
    });
    if (!state?.applyJobId) {
      getJobbyId();
    }
    fetch(constants?.ListStatesUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setStates(result);
      });
  }, []);
  const clearFilter = () => {
    window.location.reload();
  };
  // STATES
  const [states, setStates] = useState([]);

  if (!state) {
    state = {
      applyJobId: "",
      candidateName: "",
      qualification: "",
      mobile: "",
      experienceInYears: "",
      fileId: "",
      relevantExperience: "",
      currentLocation: "",
      currentOrganization: "",
      expectedCtc: "",
      currentCtc: "",
      noticePeriod: "",
      readyToRelocate: "",
      uploadResume: "",
      sourceOfCandidate: "",
    };
  }
  const [loginData, setLoginData] = useState({});
  const [uploadResume, setUpload] = useState([]);
  const [resumes, setFiles] = useState();
  const handleBlur = (e) => {
    if (e.target.value == "") {
      setError((prev) => ({
        ...prev,
        ["currentLocation"]: "Please Select State",
      }));
    } else {
      setError((prev) => ({
        ...prev,
        ["currentLocation"]: "",
      }));
    }

    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);
  };
  const onUpload = (e) => {
    let uploadFiles = e.target.files;
    setFiles(uploadFiles[0]);
  };

  const submitHandler = (e) => {
    setIsSpin(true);
    const payload = { ...loginData, assessment: jobAssessment };
    if (resumes?.size || state?.cvFileName) {
      const url = state.applyJobId
        ? `${constants.EditCandidateUrl}/${state.applyJobId}`
        : `${constants.AddCandidateUrl}/${state.jobPostId}/${loggedInUser.emailId}`;

      const fd1 = new FormData();
      fd1.append("file", resumes);

      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        // body: JSON.stringify(loginData),
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((res) => {
          var firstRes = res;
          if (res.error) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setIsSpin(false);
            }, 3000);
          } else if (resumes?.size) {
            let url = state?.fileId
              ? `${constants?.UpdateResumeUrl}/${state?.applyJobId}`
              : `${constants?.UploadResumeUrl}/${
                  state?.applyJobId || res?.data?.applyJobId
                }`;
            fetch(url, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${loggedInUser.sessionToken}`,
              },
              body: fd1,
            })
              .then((response) => response.json())
              .then((res) => {
                if (res?.error) {
                  toast.error(`❌ ${res.error.errorMessage} !`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  });
                  setTimeout(() => {
                    setIsSpin(false);
                  }, 3000);
                } else {
                  if (firstRes?.message) {
                    toast.success(
                      `✅ ${firstRes?.message?.messageDescription}`,
                      {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                      }
                    );
                    setTimeout(() => {
                      history.push({
                        pathname: "/list-candidate",
                      });
                    }, 3000);
                  }
                }
              });
          } else {
            if (res?.message) {
              toast.success(`✅ ${res?.message?.messageDescription}!`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
              setTimeout(() => {
                history.push({
                  pathname: "/list-candidate",
                });
              }, 3000);
            }
          }
        });
    } else {
      toast.error(`❌ Please attach candidate's resume!`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setTimeout(() => {
        setIsSpin(false);
      }, 3000);
    }
  };

  //validation for fields
  const [input, setInput] = useState({
    candidateName: "",
    emailId: "",
    mobile: "",
    currentOrganization: "",
    currentCtc: "",
    expectedCtc: "",
    noticePeriod: "",
    qualification: "",
    experienceInYears: "",
    relevantExperience: "",
    currentLocation: "",
    uploadResume: "",
    sourceOfCandidate: "",
  });
  const [error, setError] = useState({
    candidateName: "",
    emailId: "",
    mobile: "",
    currentOrganization: "",
    currentCtc: "",
    expectedCtc: "",
    noticePeriod: "",
    qualification: "",
    experienceInYears: "",
    relevantExperience: "",
    currentLocation: "",
    uploadResume: "",
    sourceOfCandidate: "",
  });
  const onInputChange = (e) => {
    const { name, value, file } = e.target;
    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
    validateInput(e);
  };

  const getJobbyId = (e) => {
    fetch(`${constants?.GetJobbyJobId}/${state.jobPostId}`, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setJobAssessment(result?.data?.assessment);
      });
  };

  const handleAssessmentChange = (id, value, field) => {
    // Validation logic
    if (field === "rating" && !value) {
      setError((prev) => ({
        ...prev,
        [`rating-${id}`]: "Please select a rating",
      }));
      return;
    } else if (field === "rating") {
      setError((prev) => ({
        ...prev,
        [`rating-${id}`]: "",
      }));
    }

    if (field === "comment" && value.trim() === "") {
      setError((prev) => ({
        ...prev,
        [`comment-${id}`]: "Comment cannot be empty",
      }));
      return;
    } else if (field === "comment") {
      setError((prev) => ({
        ...prev,
        [`comment-${id}`]: "",
      }));
    }

    // Update assessment state
    const updatedAssessments = jobAssessment.map((assessment) =>
      assessment.id === id ? { ...assessment, [field]: value } : assessment
    );

    setJobAssessment(updatedAssessments);
  };

  const validateInput = (e) => {
    let { name, value, type } = e.target;
    setError((prev) => {
      const stateObj = { ...prev, [name]: "" };
      switch (name) {
        case "candidateName":
          if (!value) {
            stateObj[name] = "Please Enter Agent Name.";
          }
          if (value) {
            stateObj[name] =
              [/[a-zA-Z]+/].every((pattern) => pattern.test(value)) ||
              "Invalid Name";
          }
          break;
        case "emailId":
          if (!value) {
            stateObj[name] = "Please Enter Email Id.";
          }
          if (value) {
            stateObj[name] =
              [/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/].every((pattern) =>
                pattern.test(value)
              ) || "Invalid Email Id";
          }
          break;
        case "mobile":
          if (!value) {
            stateObj[name] = "Please Enter Mobile Number.";
          } else if (value.length < 10) {
            stateObj[name] = "Should be 10 digit Mobile Number";
          }
          break;
        case "currentOrganization":
          if (!value) {
            stateObj[name] = "Please Enter current Organization.";
          }
          if (value) {
            stateObj[name] =
              [/[a-zA-Z]+/].every((pattern) => pattern.test(value)) ||
              "Invalid current Organization";
          }
          break;
        case "currentCtc":
          if (!value) {
            stateObj[name] = "Please Enter currentCtc.";
          }
          if (value) {
            stateObj[name] =
              [/[0-9]/].every((pattern) => pattern.test(value)) ||
              "Invalid currentCtc";
            if (Number(value) > 10000) {
              stateObj[name] = "please enter in LPA";
            }
          }
          break;
        case "expectedCtc":
          if (!value) {
            stateObj[name] = "Please Enter expectedCtc.";
          }
          if (value) {
            stateObj[name] =
              [/[0-9]/].every((pattern) => pattern.test(value)) ||
              "Invalid expectedCtc";
            if (Number(value) > 10000) {
              stateObj[name] = "please enter in LPA";
            }
          }
          break;
        case "noticePeriod":
          if (!value) {
            stateObj[name] = "Please Enter noticePeriod.";
          }
          if (value) {
            stateObj[name] =
              [/[0-9]/].every((pattern) => pattern.test(value)) ||
              "Invalid noticePeriod";
          }
          break;
        case "qualification":
          if (!value) {
            stateObj[name] = "please enter Qualification";
          }
          // if (value) {
          //   stateObj[name] =
          //     [/[a-zA-Z]+/].every((pattern) => pattern.test(value)) ||
          //     "Invalid Qualification";
          // }
          break;

        case "experienceInYears":
          if (!value) {
            stateObj[name] = "Please Select experience.";
          }
          break;
        case "relevantExperience":
          if (!value) {
            stateObj[name] = "Please Select relevalant experience.";
          }
          break;
        case "currentLocation":
          if (!value) {
            stateObj[name] = "Please Select location.";
          }
          break;

        case "sourceOfCandidate":
          if (!value) {
            stateObj[name] = "Please Enter Source.";
          }
          if (value) {
            stateObj[name] =
              [/[a-zA-Z]+/].every((pattern) => pattern.test(value)) ||
              "Invalid Source";

            break;
          }

        default:
          break;
      }
      return stateObj;
    });
  };
  return (
    <Fragment>
      {/* <PageTitle activeMenu="Validation" motherMenu="Form" /> */}
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Candidate's Profile</h4>
            </div>
            <div className="card-body">
              <div className="form-validation">
                <form
                  enctype="multipart/form-data"
                  className="form-valide"
                  action="#"
                  method="post"
                  onSubmit={(e) => e.preventDefault()}
                >
                  {/* firstcolumn  */}
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-username"
                        >
                          Name
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            className={
                              error.candidateName.length > 0
                                ? "is-invalid form-control"
                                : "form-control Color-box"
                            }
                            onChange={onInputChange}
                            onBlur={validateInput}
                            minLength="3"
                            name="candidateName"
                            placeholder="Enter a Name.."
                            defaultValue={state.candidateName}
                          />
                          {error.candidateName && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.candidateName}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-skill"
                        >
                          Mobile
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="number"
                            onInput={(e) => {
                              if (e.target.value.length > 10) {
                                e.target.value = e.target.value.slice(0, 10);
                              }
                            }}
                            className={
                              error.mobile.length > 0
                                ? "is-invalid form-control remove-spin  noscroll"
                                : "form-control Color-box remove-spin noscroll"
                            }
                            placeholder="+91 (XXX) XXX-XXXX"
                            // className={error.mobile.length > 0 ? "is-invalid form-control" : "form-control  Color-box"}
                            onChange={onInputChange}
                            onBlur={validateInput}
                            name="mobile"
                            maxLength="10"
                            minLength="10"
                            // placeholder="Mobile Number"
                            defaultValue={state.mobile}
                          />
                          {error.mobile && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "12px",
                                marginLeft: "6px",
                              }}
                              className="err"
                            >
                              {error.mobile}
                            </span>
                          )}
                          {/* {error.mobile && <span style={{ color: 'red',fontSize: '13px',marginLeft: '10px'  }} className='err'>{error.mobile}</span>} */}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-skill"
                        >
                          Email Id
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="email"
                            name="emailId"
                            placeholder="Email Id"
                            defaultValue={state.emailId}
                            className={
                              error.emailId.length > 0
                                ? "is-invalid form-control"
                                : "form-control Color-box"
                            }
                            onChange={onInputChange}
                            onBlur={validateInput}
                          />
                          {error.emailId && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.emailId}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-website"
                        >
                          Experience(in year)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="number"
                            min="0"
                            // className="form-control Color-box"
                            className={
                              error.experienceInYears.length > 0
                                ? "is-invalid form-control  noscroll"
                                : "form-control Color-box  noscroll"
                            }
                            name="experienceInYears"
                            placeholder="Experience In Years"
                            minLength="3"
                            maxLength="12"
                            // onChange={handleBlur}
                            defaultValue={state.experienceInYears}
                            onChange={onInputChange}
                            onBlur={validateInput}
                          />
                          {error.experienceInYears && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.experienceInYears}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-website"
                        >
                          Relevant Experience(in year)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="number"
                            min="0"
                            // className="form-control Color-box"
                            className={
                              error.relevantExperience.length > 0
                                ? "is-invalid form-control noscroll"
                                : "form-control Color-box noscroll"
                            }
                            name="relevantExperience"
                            placeholder="Relevant Experience"
                            minLength="3"
                            maxLength="12"
                            // onChange={handleBlur}
                            onChange={onInputChange}
                            onBlur={validateInput}
                            defaultValue={state.relevantExperience}
                          />
                          {error.relevantExperience && (
                            <span
                              style={{ color: "red", fontSize: "12px" }}
                              className="err"
                            >
                              {error.relevantExperience}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-confirm-password"
                        >
                          Current CTC(LPA){""}
                          <span className="text-danger">*</span>
                        </label>

                        <div className="col-lg-6">
                          <input
                            type="number"
                            min="0"
                            // className="form-control Color-box"
                            className={
                              error.currentCtc.length > 0
                                ? "is-invalid form-control noscroll"
                                : "form-control Color-box  noscroll"
                            }
                            name="currentCtc"
                            placeholder="Current CTC"
                            // onChange={handleBlur}
                            defaultValue={state.currentCtc}
                            onChange={onInputChange}
                            onBlur={validateInput}
                          />
                          {error.currentCtc && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.currentCtc}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-confirm-password"
                        >
                          Expected CTC(LPA){""}
                          <span className="text-danger">*</span>
                        </label>

                        <div className="col-lg-6">
                          <input
                            type="number"
                            min="0"
                            // className="form-control Color-box"
                            className={
                              error.expectedCtc.length > 0
                                ? "is-invalid form-control noscroll"
                                : "form-control Color-box noscroll"
                            }
                            name="expectedCtc"
                            placeholder="Expected CTC.."
                            defaultValue={state.expectedCtc}
                            // onChange={handleBlur}
                            onChange={onInputChange}
                            onBlur={validateInput}
                          />
                          {error.expectedCtc && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.expectedCtc}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* 2ndcolumn */}

                    <div className="col-xl-6">
                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          Current Location (State)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <select
                            name="currentLocation"
                            onChange={handleBlur}
                            // className="form-control Color-box"
                            className={
                              error?.currentLocation
                                ? "form-control Color-box is-invalid"
                                : "form-control Color-box "
                            }
                          >
                            <option value="">Please select</option>

                            {states?.map((currentLocation) => (
                              <option
                                selected={
                                  state?.currentLocation ===
                                  currentLocation.stateName
                                    ? state?.currentLocation
                                    : ""
                                }
                                value={currentLocation.stateName}
                              >
                                {currentLocation.stateName}
                              </option>
                            ))}
                          </select>
                          {error.currentLocation && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.currentLocation}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-password"
                        >
                          Qualification
                          <span className="text-danger">*</span>
                        </label>

                        <div className="col-lg-6">
                          <input
                            type="text"
                            name="qualification"
                            defaultValue={state?.qualification}
                            placeholder="Qualification."
                            onChange={onInputChange}
                            onBlur={validateInput}
                            className={
                              error.qualification.length > 0
                                ? "is-invalid form-control"
                                : "form-control Color-box"
                            }
                          />
                          {state.qualification && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.qualification}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-phoneus"
                        >
                          Current organization
                          <span className="text-danger">*</span>
                        </label>

                        <div className="col-lg-6">
                          <input
                            type="text"
                            name="currentOrganization"
                            placeholder="Current Organization"
                            defaultValue={state.currentOrganization}
                            onChange={onInputChange}
                            onBlur={validateInput}
                            className={
                              error.currentOrganization.length > 0
                                ? "is-invalid form-control"
                                : "form-control Color-box"
                            }
                          />
                          {error.currentOrganization && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "6px",
                              }}
                              className="err"
                            >
                              {error.currentOrganization}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          Notice period(in day){""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="number"
                            min="0"
                            // className="form-control Color-box"
                            className={
                              error.noticePeriod.length > 0
                                ? "is-invalid form-control noscroll"
                                : "form-control Color-box noscroll"
                            }
                            name="noticePeriod"
                            placeholder="Notice Period.."
                            // onChange={handleBlur}
                            defaultValue={state.noticePeriod}
                            onChange={onInputChange}
                            onBlur={validateInput}
                          />
                          {error.noticePeriod && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.noticePeriod}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label Description-Label">
                          Ready to relocate{""}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6 col-form-label">
                          <input
                            type="radio"
                            defaultChecked={
                              state.readyToRelocate == "yes"
                                ? state.readyToRelocate
                                : ""
                            }
                            value="yes"
                            name="readyToRelocate"
                            onChange={handleBlur}
                          />{" "}
                          Yes <br></br>
                          <input
                            type="radio"
                            defaultChecked={
                              state.readyToRelocate == "no"
                                ? state.readyToRelocate
                                : ""
                            }
                            value="no"
                            name="readyToRelocate"
                            onChange={handleBlur}
                          />{" "}
                          No <br></br>
                          <input
                            type="radio"
                            defaultChecked={
                              state.readyToRelocate == "na"
                                ? state.readyToRelocate
                                : ""
                            }
                            value="na"
                            name="readyToRelocate"
                            onChange={handleBlur}
                          />{" "}
                          NA
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-suggestions"
                        >
                          Upload Resume
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="file"
                            accept=".pdf,.doc,.docx"
                            name="file"
                            id="fileResume"
                            onChange={(e) => onUpload(e)}
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="Existing Resume"
                        >
                          Existing Resume:
                        </label>
                        <label className="col-lg-6" style={{ marginTop: 6 }}>
                          {state.cvFileName || "None"}
                        </label>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-4 col-form-label Description-Label"
                          htmlFor="val-source"
                        >
                          Source of Candidate
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            name="sourceOfCandidate"
                            placeholder="Source of Candidate"
                            defaultValue={state.sourceOfCandidate}
                            className={
                              error.sourceOfCandidate &&
                              error.sourceOfCandidate.length > 0
                                ? "is-invalid form-control"
                                : "form-control Color-box"
                            }
                            onChange={onInputChange}
                            onBlur={validateInput}
                          />
                          {error.sourceOfCandidate && (
                            <span
                              style={{
                                color: "red",
                                fontSize: "13px",
                                marginLeft: "10px",
                              }}
                              className="err"
                            >
                              {error.source}
                            </span>
                          )}
                        </div>
                      </div>

                      {jobAssessment?.map((assessment) => (
                        <div className="form-group row" key={assessment.id}>
                          <label
                            className="col-lg-12 col-form-label Description-Label"
                            htmlFor={`assessment-${assessment.id}`}
                          >
                            {assessment.question}
                            <span className="text-danger">*</span>
                          </label>

                          {/* Added description text below the question */}
                          <span className="col-lg-12 rating-description">
                            (Rate the skill on a scale of 1 to 5, where 1
                            represents extremely poor and 5 signifies
                            excellent.)
                          </span>

                          <div className="col-lg-12">
                            {[1, 2, 3, 4, 5].map((rating) => (
                              <label key={rating} className="mr-3">
                                <input
                                  type="radio"
                                  value={rating}
                                  name={`rating-${assessment.id}`}
                                  checked={assessment.rating == rating}
                                  onChange={(e) =>
                                    handleAssessmentChange(
                                      assessment.id,
                                      e.target.value,
                                      "rating"
                                    )
                                  }
                                />{" "}
                                {rating}
                              </label>
                            ))}
                            {error[`rating-${assessment.id}`] && (
                              <div className="text-danger">
                                {error[`rating-${assessment.id}`]}
                              </div>
                            )}

                            {/* Comment Section */}
                            <textarea
                              className="form-control mt-3"
                              placeholder="Enter your comment here..."
                              value={assessment.comment || ""}
                              onChange={(e) =>
                                handleAssessmentChange(
                                  assessment.id,
                                  e.target.value,
                                  "comment"
                                )
                              }
                            />
                            {error[`comment-${assessment.id}`] && (
                              <div className="text-danger">
                                {error[`comment-${assessment.id}`]}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}

                      <div className="form-group row">
                        <div className="col-lg-12 ml-auto">
                          {isSpin ? (
                            <button
                              style={{
                                border: "none",
                                backgroundColor: "#00ADEE",
                                marginTop: 11,
                                marginBottom: 21,
                              }}
                              type="button"
                              className="btn btn-primary"
                            >
                              <CircularProgress
                                color="inherit"
                                size={24}
                                sx={{
                                  color: "green",
                                }}
                              />
                            </button>
                          ) : (
                            <button
                              style={{
                                border: "none",
                                backgroundColor: "#00ADEE",
                                marginTop: 11,
                                marginBottom: 21,
                              }}
                              type="submit"
                              className="btn btn-primary"
                              onClick={submitHandler}
                            >
                              Submit
                            </button>
                          )}
                          &nbsp;&nbsp;
                          <button
                            style={{
                              border: "none",
                              backgroundColor: "#00ADEE",
                              marginTop: 11,
                              marginBottom: 21,
                            }}
                            type="submit"
                            className="btn btn-primary"
                            // onClick={handleBlur}
                            onClick={clearFilter}
                          >
                            Reset
                          </button>
                          <ToastContainer />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default ApplyJob;
